import { DialogButton } from './message-dialog';
import './scroll-message-dialog.scss';

export type ScrollMessageDialogProps = {
  // - スクロール領域の前に固定表示するメッセージ -
  header?: string[];
  // - スクロールする領域に表示するメッセージ(ブロック間は1行分の余白を空ける) -
  message: string[][];
  // - スクロール領域の後に固定表示するメッセージ -
  footer?: string[];
  // - ボタンリスト -
  buttons: {
    label: string,
    callback: () => void,
    options?: {
      waitActive?: number,
    },
  }[];
};

/** 固定表示するメッセージ(header / footer)。prefix はキーの衝突を避けるための識別子 */
const Comment = (props: { prefix: string, message: string[] }) => (
  <>
    {props.message.map((v, i) => (
      <div
        key={`scroll-message-dialog-${props.prefix}_${i}`}
        className="dialog_contents__body__comment"
      >{v || <br />}</div>
    ))}
  </>
);

/**
 * 件数が可変のリストを含むメッセージダイアログ。
 * リストが長くなってもメッセージの要点とボタンが隠れないよう、
 * message のみをスクロール領域とし header / footer / ボタンは常に表示する。
 * リストを持たない通常のメッセージは MessageDialog を使う
 */
export const ScrollMessageDialog = (props: ScrollMessageDialogProps) => {
  const { header, message, footer, buttons } = props;
  return (
    <div className="dialog_contents scroll_message_dialog">
      <div className="dialog_contents__body">
        {header?.length ? <Comment prefix="header" message={header} /> : <></>}
        <div className="scroll_message_dialog__scroll">
          {message.map((block, i) => (
            <div
              key={`scroll-message-dialog-block_${i}`}
              className="scroll_message_dialog__scroll__block"
            >
              {block.map((v, j) => (
                <div
                  key={`scroll-message-dialog-block-text_${i}_${j}`}
                  className="dialog_contents__body__comment"
                >{v || <br />}</div>
              ))}
            </div>
          ))}
        </div>
        {footer?.length ? <Comment prefix="footer" message={footer} /> : <></>}
      </div>
      <div className="dialog_contents__footer">
        {buttons.map((v, i) => (
          <div key={`scroll-message-dialog-button_${i}`}>
            <DialogButton
              label={v.label}
              callback={v.callback}
              buttons={buttons}
              options={v.options}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
